export const GET_COUNTRY = "GET_COUNTRY"
export const GET_COUNTRY_SUCCESS = "GET_COUNTRY_SUCCESS"
export const GET_COUNTRY_FAIL = "GET_COUNTRY_FAIL"


export const ADD_COUNTRY = "ADD_COUNTRY"
export const ADD_COUNTRY_SUCCESS = "ADD_COUNTRY_SUCCESS"
export const ADD_COUNTRY_FAIL = "ADD_COUNTRY_FAIL"

export const UPDATE_COUNTRY = "UPDATE_COUNTRY"
export const UPDATE_COUNTRY_SUCCESS = "UPDATE_COUNTRY_SUCCESS"
export const UPDATE_COUNTRY_FAIL = "UPDATE_COUNTRY_FAIL"

export const DELETE_COUNTRY = "DELETE_COUNTRY"
export const DELETE_COUNTRY_SUCCESS = "DELETE_COUNTRY_SUCCESS"
export const DELETE_COUNTRY_FAIL = "DELETE_COUNTRY_FAIL"

export const COUNTRY_API_ERROR = "API_ERROR"
